import MuiTableContainer from '@mui/material/TableContainer';
import { styled } from '@mui/material/styles';

export const TableContainer = styled(MuiTableContainer)`
  max-height: 260px;
`;
